import React from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, Languages, ArrowDown } from "lucide-react";

const OneProductCard = ({ product }) => {

    const navigate = useNavigate();

    const handleClick = (path) => {
        navigate(path);
    };
    // console.log('product',product);
    const discount = Math.round(((product.product_mrp - product.product_selling_price) / product.product_mrp) * 100);

    return (
        <div className="p-2 flex-shrink-0 w-full sm:w-[290px] md:w-[310px] bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 scroll-snap-align-start">
            <img src={product.desc_header_image} alt={product.product_title_english} className="w-full h-[150px] object-fill"/>
            <div className="p-1 relative">
                <h3 className="text-lg font-bold text-gray-800 line-clamp-2 min-h-[3.25rem]">{product.product_title_english}</h3>
                <div className="flex flex-wrap gap-2 mt-2">
                    {(product.is_emi_available == 1 ? ['Available on EMI',product.product_category_type_name]: [product.product_category_type_name]).map((tag, index) => (
                        <span
                            key={index}
                            className="px-2 py-1 text-xs font-semibold text-[#4f6cbb] bg-blue-100 rounded-full"
                        >
                            {tag}
                        </span>
                    ))}
                </div>
                <div className="flex items-center justify-between text-sm text-gray-600 mt-4">
                    <div className="flex items-center gap-2">
                        <Calendar className="w-4 h-4 text-[#4f6cbb]" />
                        <span className="font-bold">Validity: {product.validity == 0 ? 'NA' : `${product.validity} Months` }</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <Languages className="w-4 h-4 text-[#4f6cbb]" />
                        <span className="font-bold">Medium: {product.product_lang}</span>
                    </div>
                </div>
                <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center gap-2">
                        <span className="text-xl font-bold text-[#4f6cbb]">₹{product.product_selling_price.toLocaleString()}</span>
                        {
                            product.product_selling_price != product.product_mrp
                            &&
                            (
                                <span className="text-sm text-gray-400 line-through">
                                    ₹{product.product_mrp.toLocaleString()}
                                </span>
                            )
                        }
                    </div>
                    {
                        discount > 0 &&
                        (
                            <div className="flex items-center gap-1 text-sm text-green-600 font-bold bg-green-100 px-2 py-1 rounded-full">
                                <ArrowDown className="w-4 h-4 text-green-600" />
                                <span>
                                    {Math.round(((product.product_mrp - product.product_selling_price) / product.product_mrp) * 100)}% Off
                                </span>
                            </div>
                        )
                    }
                    
                </div>
                <div className="grid grid-cols-2 gap-3 mt-4">
                    <button className="px-4 py-2 text-sm border-2 border-[#4f6cbb] text-[#4f6cbb] rounded-lg hover:bg-blue-50" onClick={() => handleClick(product.course_seo_url)}>
                        View Details
                    </button>
                    <button className="px-4 py-2 text-sm bg-[#4f6cbb] text-white rounded-lg hover:bg-[#4f6cbb]" onClick={() => handleClick('pay/'+product.product_id)}>
                        Buy Now
                    </button>
                </div>
            </div>
        </div>
    )
};

export default OneProductCard;
